import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { GeckoBtn } from 'ui';
import './index.scss';

function FilePicker(props) {
  const fileInput = useRef(null);

  const handleChange = (event) => {
    const file = event.target.files[0];
    props.onFilePicked(file);
  };

  return (
    <div className="FilePicker">
      <GeckoBtn
        name="Upload File"
        icon="far fa-cloud-upload"
        handler={() => fileInput.current.click()}
      />
      <input
        type="file"
        disabled={props.disabled}
        onChange={handleChange}
        accept=".csv"
        ref={fileInput}
      />
    </div>
  );
}

FilePicker.propTypes = {
  onFilePicked: PropTypes.func,
  disabled: PropTypes.bool,
};

FilePicker.defaultProps = {
  onFilePicked: () => {},
  disabled: false,
};

export default FilePicker;
